import { GET } from '@/plugins/axios'

const baseUrl = `${process.env.VUE_APP_PINES}/pines/member`

export const getPinesMemberEmployees = async (params = {}) => {
  return GET(`${baseUrl}/employees`, params)
}
